import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BodyText,
  Button,
  DropdownMenu,
  HeadingText,
  Link,
  TextArea,
  TextInput,
  V2CriticalIcon,
} from '@paypalcorp/pp-react';
import { sendEmailNoIntent } from '../actions/action-email-form-no-intent';
import Page from '../../lib/page';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import i18n from '../../lib/reacti18n';
import { getComplaintsPageInfo, isComplaintsCountryLocaleEnabled } from '../../lib/globalHelper';
import { urlConstants } from '../../common/commonConstants';

const complaintsTranslations = {
  webformPageTitle: i18n.message('smarthelp/complaints.complaintsPage.webformPageTitle'),
  webformComplaintHeader: i18n.message('smarthelp/complaints.complaintsPage.webformComplaintHeader'),
  webformComplaintText: i18n.message('smarthelp/complaints.complaintsPage.webformComplaintText'),
  webformWhenHeader: i18n.message('smarthelp/complaints.complaintsPage.webformWhenHeader'),
  webformWhentext: i18n.message('smarthelp/complaints.complaintsPage.webformWhentext'),
  modalSelectDefault: i18n.message('smarthelp/complaints.complaintsPage.modalSelectDefault'),
  modalSelectOption1: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption1'),
  modalSelectOption2: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption2'),
  modalSelectOption3: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption3'),
  modalSelectOption4: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption4'),
  modalSelectOption9: i18n.message('smarthelp/complaints.complaintsPage.modalSelectOption9'),
  webformFirstName: i18n.message('smarthelp/complaints.complaintsPage.webformFirstName'),
  webformLastName: i18n.message('smarthelp/complaints.complaintsPage.webformLastName'),
  webformEmail: i18n.message('smarthelp/complaints.complaintsPage.webformEmail'),
  webformPhone: i18n.message('smarthelp/complaints.complaintsPage.webformPhone'),
  webformReferenceHeader: i18n.message('smarthelp/complaints.complaintsPage.webformReferenceHeader'),
  webformReferenceText: i18n.message('smarthelp/complaints.complaintsPage.webformReferenceText'),
  webformComplaint: i18n.message('smarthelp/complaints.complaintsPage.webformComplaint'),
  webformFeedback: i18n.message('smarthelp/complaints.complaintsPage.webformFeedback'),
  webformDeclarationHeader: i18n.message('smarthelp/complaints.complaintsPage.webformDeclarationHeader'),
  webformDeclarationText: i18n.message('smarthelp/complaints.complaintsPage.webformDeclarationText'),
  webformSign: i18n.message('smarthelp/complaints.complaintsPage.webformSign'),
  webformSignText: i18n.message('smarthelp/complaints.complaintsPage.webformSignText'),
  webformInfo: i18n.message('smarthelp/complaints.complaintsPage.webformInfo', {
    helpCenterUrl: urlConstants.HELP_CENTER_URL,
    emailUrl: urlConstants.EMAIL_URL,
    contactUsUrl: urlConstants.CONTACT_US_URL,
  }),
  webformInfo1: i18n.message('smarthelp/complaints.complaintsPage.webformInfo1'),
  webformInfo2: i18n.message('smarthelp/complaints.complaintsPage.webformInfo2'),
  webformInfo3: i18n.message('smarthelp/complaints.complaintsPage.webformInfo3'),
  webformSubmitButtonText: i18n.message('smarthelp/complaints.complaintsPage.webformSubmitButtonText'),
  webformFooterText: i18n.message('smarthelp/complaints.complaintsPage.webformFooterText'),
  webformFooterText1: i18n.message('smarthelp/complaints.complaintsPage.webformFooterText1'),
  webformError: i18n.message('smarthelp/complaints.complaintsPage.webformError'),
};

const complaintOptions = [
  {
    primaryText: complaintsTranslations.modalSelectOption1,
    value: 'FEEDCOMPLAIN011',
  },
  {
    primaryText: complaintsTranslations.modalSelectOption2,
    value: 'FEEDCOMPLAIN012',
  },
  {
    primaryText: complaintsTranslations.modalSelectOption3,
    value: 'FEEDCOMPLAIN013',
  },
  {
    primaryText: complaintsTranslations.modalSelectOption4,
    value: 'FEEDCOMPLAIN014',
  },
  {
    primaryText: complaintsTranslations.modalSelectOption9,
    value: 'FEEDCOMPLAIN019',
  },
];

const EmailWebformNoTCode = (props) => {
  const { complaintReasonQuery } = props;

  const [formData, updateFormData] = useState({});

  const complaintsLabel = () => {
    if (complaintReasonQuery) {
      formData.complaint_reason = complaintReasonQuery;
      const complaintLabel = complaintOptions.find((complaint) => complaint.value === complaintReasonQuery);
      return (complaintLabel && complaintLabel.primaryText) || '';
    }
    return '';
  };

  const dispatch = useDispatch();

  // initializing state using react hooks
  const [complaintSelectedValue, updateComplaintSelectedValue] = useState(complaintReasonQuery);
  const [complaintSelectedLabel, updateComplaintSelectedLabel] = useState(complaintsLabel());
  const [complaintReasonErrorText, updateComplaintReasonErrorText] = useState('');
  const [firstNameErrorText, updateFirstNameErrorText] = useState('');
  const [lastNameErrorText, updateLastNameErrorText] = useState('');
  const [emailErrorText, updateEmailErrorText] = useState('');
  const [phoneErrorText, updatePhoneErrorText] = useState('');
  const [compliantTextErrorText, updateCompliantTextErrorText] = useState('');
  const [messageErrorText, updateMessageErrorText] = useState('');
  const [signatureFirstNameErrorText, updateSignatureFirstNameErrorText] = useState('');
  const [signatureLastNameErrorText, updateSignatureLastNameErrorText] = useState('');

  const { error } = useSelector((state) => state.emailNoIntent);

  const renderError = () => {
    return (
      <div className="error-email-no-intent">
        <V2CriticalIcon size="xl" />
        <BodyText>{Page.getHTMLElement({ message: complaintsTranslations.webformError, useHTML: true })}</BodyText>
      </div>
    );
  };

  // Updating the error text for required fields when empty
  const updateErrorText = (value = '', updateState) => {
    updateState(value);
  };

  /**
   * Updating the stae wih each form element value
   */
  const formValueChanged = (keyName, e, updateState) => {
    formData[keyName] = e.target.value;

    if (keyName === 'complaint_reason') {
      const selectedLabel =
        complaintOptions[e.target.selectedIndex] && complaintOptions[e.target.selectedIndex].primaryText;
      updateComplaintSelectedValue(e.target.value);
      updateComplaintSelectedLabel(selectedLabel);
      trackPage({ id: 'complaintsDropdownChange', link: `smarthelp-webform-dropdown-change|${e.target.value}` });
    }

    /**
     * As ref_number in not required not updating the error state
     */
    if (keyName !== 'ref_number') {
      updateErrorText('', updateState);
    }

    updateFormData(formData);
  };

  /**
   * Function for Email submission
   */
  const submitClicked = () => {
    const stateData = formData;
    if (!complaintSelectedValue) {
      updateErrorText('Required', updateComplaintReasonErrorText);
    }
    if (!stateData.first_name) {
      updateErrorText('Required', updateFirstNameErrorText);
    }
    if (!stateData.last_name) {
      updateErrorText('Required', updateLastNameErrorText);
    }
    if (!stateData.email) {
      updateErrorText('Required', updateEmailErrorText);
    }
    if (!stateData.phone) {
      updateErrorText('Required', updatePhoneErrorText);
    }
    if (!stateData.compliant_text) {
      updateErrorText('Required', updateCompliantTextErrorText);
    }
    if (!stateData.message) {
      updateErrorText('Required', updateMessageErrorText);
    }
    if (!stateData.signature_first_name) {
      updateErrorText('Required', updateSignatureFirstNameErrorText);
    }
    if (!stateData.signature_last_name) {
      updateErrorText('Required', updateSignatureLastNameErrorText);
    }
    if (
      complaintSelectedValue &&
      complaintSelectedLabel &&
      stateData.first_name &&
      stateData.last_name &&
      stateData.email &&
      stateData.phone &&
      stateData.compliant_text &&
      stateData.message &&
      stateData.signature_first_name &&
      stateData.signature_last_name
    ) {
      stateData.topic_code = complaintSelectedValue;
      stateData.subTopicName = complaintSelectedLabel;
      stateData.subject = complaintSelectedLabel;
      stateData.topicName = complaintSelectedLabel;
      stateData._csrf = Page.getCSRFtoken();
      trackLink({
        id: 'complaintsSubmit',
        link: `smarthelp-webform-submit-clicked|${complaintSelectedValue}`,
      });
      dispatch(
        sendEmailNoIntent({
          emailPayload: stateData,
          _csrf: Page.getCSRFtoken(),
        }),
      );
    } else {
      window.scroll({
        top: 400,
        behavior: 'smooth',
      });
    }
  };

  const complaintsLinkClick = (urlClicked) => {
    trackLink({ id: 'complaintsPage', link: `smarthelp-complaints-page-complaints-link-clicked|${urlClicked}` });
  };

  const renderEmailComplaintsWebForm = () => {
    if (error) {
      return renderError();
    }

    const complaintsTextInfo = getComplaintsPageInfo();
    return (
      <div className="complaints_web_form">
        <HeadingText size="lg">{complaintsTranslations.webformPageTitle}</HeadingText>
        <br />
        <BodyText strong>{complaintsTranslations.webformComplaintHeader}</BodyText>
        <br />
        <BodyText>{complaintsTranslations.webformComplaintText}</BodyText>
        <br />
        <BodyText strong>{complaintsTranslations.webformWhenHeader}</BodyText>
        <br />
        <BodyText>{Page.getHTMLElement({ message: complaintsTranslations.webformWhentext, useHTML: true })}</BodyText>
        <br />
        <DropdownMenu
          label={complaintsTranslations.modalSelectDefault}
          theme="v2"
          onChange={(e) => formValueChanged('complaint_reason', e, updateComplaintReasonErrorText)}
          value={complaintSelectedValue}
          errorText={complaintReasonErrorText}
          options={complaintOptions}
        />
        <br />
        <TextInput
          name="basic"
          errorText={firstNameErrorText}
          onChange={(e) => formValueChanged('first_name', e, updateFirstNameErrorText)}
          label={complaintsTranslations.webformFirstName}
        />
        <br />
        <TextInput
          name="basic"
          errorText={lastNameErrorText}
          onChange={(e) => formValueChanged('last_name', e, updateLastNameErrorText)}
          label={complaintsTranslations.webformLastName}
        />
        <br />
        <TextInput
          name="basic"
          errorText={emailErrorText}
          onChange={(e) => formValueChanged('email', e, updateEmailErrorText)}
          label={complaintsTranslations.webformEmail}
        />
        <br />
        <TextInput
          name="basic"
          errorText={phoneErrorText}
          onChange={(e) => formValueChanged('phone', e, updatePhoneErrorText)}
          label={complaintsTranslations.webformPhone}
        />
        <br />
        <BodyText>{complaintsTranslations.webformReferenceHeader}</BodyText>
        <br />
        <TextInput
          name="basic"
          onChange={(e) => formValueChanged('ref_number', e)}
          label={complaintsTranslations.webformReferenceText}
        />
        <br />
        <BodyText>{complaintsTranslations.webformComplaint}</BodyText>
        <br />
        <TextArea
          name="withMinRows"
          errorText={compliantTextErrorText}
          minRows={4}
          onChange={(e) => formValueChanged('compliant_text', e, updateCompliantTextErrorText)}
        />
        <br />
        <BodyText>{complaintsTranslations.webformFeedback}</BodyText>
        <br />
        <TextArea
          name="withMinRows"
          errorText={messageErrorText}
          minRows={4}
          onChange={(e) => formValueChanged('message', e, updateMessageErrorText)}
        />
        <br />
        <BodyText>{complaintsTranslations.webformDeclarationHeader}</BodyText>
        <br />
        <BodyText>{complaintsTranslations.webformDeclarationText}</BodyText>
        <br />
        <BodyText>{complaintsTranslations.webformSign}</BodyText>
        <br />
        <TextInput
          name="basic"
          errorText={signatureFirstNameErrorText}
          onChange={(e) => formValueChanged('signature_first_name', e, updateSignatureFirstNameErrorText)}
          label={complaintsTranslations.webformFirstName}
        />
        <br />
        <TextInput
          name="basic"
          errorText={signatureLastNameErrorText}
          onChange={(e) => formValueChanged('signature_last_name', e, updateSignatureLastNameErrorText)}
          label={complaintsTranslations.webformLastName}
        />
        <br />
        <BodyText>{complaintsTranslations.webformSignText}</BodyText>
        <br />
        <BodyText>{Page.getHTMLElement({ message: complaintsTranslations.webformInfo, useHTML: true })}</BodyText>
        <BodyText>
          {Page.getCountry() === 'uk' || Page.getCountry() === 'gb'
            ? complaintsTextInfo.complaintWebformAgreementUK
            : complaintsTranslations.webformInfo1}
        </BodyText>
        <BodyText>{complaintsTranslations.webformInfo2}</BodyText>
        <BodyText>{complaintsTranslations.webformInfo3}</BodyText>
        <br />
        <Button
          onClick={() => {
            submitClicked();
          }}
        >
          {complaintsTranslations.webformSubmitButtonText}
        </Button>
        <br />
        <br />
        {isComplaintsCountryLocaleEnabled() ? (
          <BodyText className="complaints_webform_footer_text">
            {complaintsTranslations.webformFooterText}
            <Link
              href={complaintsTextInfo.superviseDentitiesUrl}
              onClick={() => complaintsLinkClick(complaintsTextInfo.superviseDentitiesUrl)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {complaintsTextInfo.superviseDentitiesUrl}
            </Link>
            {complaintsTranslations.webformFooterText1}
          </BodyText>
        ) : (
          <div>
            <BodyText>
              {Page.getCountry() === 'uk' || Page.getCountry() === 'gb'
                ? complaintsTextInfo.complaintWebformFooterTextUK
                : complaintsTextInfo.complaintWebformFooterText}
            </BodyText>
          </div>
        )}
      </div>
    );
  };

  return renderEmailComplaintsWebForm();
};

export default EmailWebformNoTCode;
